import { useMutation, useQueryClient } from 'react-query';
import { API } from '../../../utils/ApiClient';

function useDeleteTranslationOffer() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }: { id?: string }) => API.delete('/translationoffers/' + id),
        onSuccess() {
            queryClient.invalidateQueries('translationoffers');
        },
    });
}

export default useDeleteTranslationOffer;
